export  const  defaultTexts={
    title:'Art-Residence',
    description:"Art-Residence",
}
